(function(){
  var V = "20260804f";
  var base = (document.currentScript && document.currentScript.src ? document.currentScript.src : "").replace(/[^\/]+$/, "");
  var parts = ["nf-stage-0.js","nf-stage-a.js","nf-stage-b.js","nf-stage-b2.js","nf-stage-c.js"];
  Promise.all(parts.map(function(p){
    return fetch(base + p + "?v=" + V, { cache: "reload" }).then(function(r){ return r.text(); });
  })).then(function(chunks){
    var src = chunks.join("");
    var tag = document.createElement("script");
    tag.text = src;
    (document.head || document.documentElement).appendChild(tag);
  }).catch(function(e){ console.error("NF loader failed to assemble script", e); });
})();
